import { render, staticRenderFns } from "./TemporaryAccess.vue?vue&type=template&id=f4070440&scoped=true&"
import script from "./TemporaryAccess.vue?vue&type=script&lang=js&"
export * from "./TemporaryAccess.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryAccess.vue?vue&type=style&index=0&id=f4070440&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4070440",
  null
  
)

export default component.exports